import { render, staticRenderFns } from "./ProjectServices.vue?vue&type=template&id=c7aee9de&scoped=true&"
import script from "./ProjectServices.vue?vue&type=script&lang=js&"
export * from "./ProjectServices.vue?vue&type=script&lang=js&"
import style0 from "./ProjectServices.vue?vue&type=style&index=0&id=c7aee9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aee9de",
  null
  
)

export default component.exports